<div class="modal-header bg-dark">
    <h4 class="modal-title">Note pratica <strong>{{ request.IDRequest }}</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<div class="modal-body">
    <app-request-notes [idRequest]="request.IDRequest"
                       (notesCountChange)="onNotesCountChange($event)">
    </app-request-notes>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.dismiss()">Chiudi</button>
</div>
